export default "__VITE_ASSET__HfyxT$bm__"